import styled from 'styled-components';
import { Box } from '@/shared/ui/box/Box';

const TermsCard = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export { TermsCard }